export function parseVersionTags(text: string): string[] {
	return Array.from(new Set(text.split(/\r?\n/).map((tag) => tag.trim()).filter(Boolean)));
}
